var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "applicant-information", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-row",
        { staticClass: "px-5" },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("1. Akademischer Titel (optional)")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.titel))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "title",
                      autocomplete: "off",
                      outlined: "",
                      dense: ""
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("titel", v)
                      }
                    },
                    model: {
                      value: _vm.formData.titel,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "titel", $$v)
                      },
                      expression: "formData.titel"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("2. Geschlecht")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.geschlecht))
                  ])
                : _c("v-select", {
                    attrs: {
                      id: "geschlecht",
                      outlined: "",
                      dense: "",
                      placeholder: "Bitte Auswählen!",
                      "persistent-placeholder": "",
                      items: _vm.genders,
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("geschlecht", v)
                      }
                    },
                    model: {
                      value: _vm.formData.geschlecht,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "geschlecht", $$v)
                      },
                      expression: "formData.geschlecht"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v(
                  "3. Vorname(n) des Antragstellers* bzw. Unterzeichnungsbefugten*"
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.vorname))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "vorname",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/[^()\d]+/g)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("vorname", v)
                      }
                    },
                    model: {
                      value: _vm.formData.vorname,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "vorname", $$v)
                      },
                      expression: "formData.vorname"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v(
                  "4. Name(n) des Antragstellers* bzw. Unterzeichnungsbefugten*"
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.name))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "name",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/[^()\d]+/)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("name", v)
                      }
                    },
                    model: {
                      value: _vm.formData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("5. Geburtsdatum")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatDateTime(
                          _vm.formData.geburtstag,
                          "DD.MM.YYYY"
                        )
                      )
                    )
                  ])
                : _c("n-date-picker", {
                    ref: "birthday",
                    attrs: {
                      id: "birthday",
                      "max-date": _vm.getDateByOffset(-18),
                      "min-date": _vm.getDateByOffset(-110),
                      "input-rules": [
                        _vm.rules.between_age(18, 110),
                        _vm.rules.required,
                        _vm.rules.valid_date("DD.MM.YYYY")
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("geburtstag", v)
                      }
                    },
                    model: {
                      value: _vm.formData.geburtstag,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "geburtstag", $$v)
                      },
                      expression: "formData.geburtstag"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("6. Straße")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.strasse))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "strasse",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/^(?:(?!\s\d+).)*$/)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("strasse", v)
                      }
                    },
                    model: {
                      value: _vm.formData.strasse,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "strasse", $$v)
                      },
                      expression: "formData.strasse"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("7. Hausnummer")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.hausnummer))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "hausnummer",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/\d+.*/)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("hausnummer", v)
                      }
                    },
                    model: {
                      value: _vm.formData.hausnummer,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "hausnummer", $$v)
                      },
                      expression: "formData.hausnummer"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("8. Postleitzahl")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.plz))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "plz",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/\d{5}/)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("plz", v)
                      }
                    },
                    model: {
                      value: _vm.formData.plz,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "plz", $$v)
                      },
                      expression: "formData.plz"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [_vm._v("9. Ort")]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.ort))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "ort",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/[^\d]+.*/)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("ort", v)
                      }
                    },
                    model: {
                      value: _vm.formData.ort,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "ort", $$v)
                      },
                      expression: "formData.ort"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("10. Bundesland")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.getStateById(_vm.formData.bundesland)))
                  ])
                : _c("v-select", {
                    attrs: {
                      id: "bundesland",
                      outlined: "",
                      dense: "",
                      placeholder: "Bitte Auswählen!",
                      "persistent-placeholder": "",
                      items: _vm.states,
                      "item-text": "text",
                      "item-value": "id",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("bundesland", v)
                      }
                    },
                    model: {
                      value: _vm.formData.bundesland,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bundesland", $$v)
                      },
                      expression: "formData.bundesland"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("11. E-Mail-Adresse für die Antragskommunikation")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.email))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "email",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [_vm.rules.required, _vm.rules.email]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("email", v)
                      }
                    },
                    model: {
                      value: _vm.formData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email"
                    }
                  })
            ],
            1
          ),
          !_vm.readonly
            ? _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("label", { staticClass: "primary--text" }, [
                    _vm._v(
                      "12. E-Mail-Adresse zur Prüfung bitte erneut eintragen"
                    )
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      id: "email_confirm",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.email,
                        _vm.rules.same_as(_vm.formData.email)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("email_confirm", v)
                      },
                      paste: function(e) {
                        return e.preventDefault()
                      }
                    },
                    model: {
                      value: _vm.formData.email_confirm,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "email_confirm", $$v)
                      },
                      expression: "formData.email_confirm"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("13. Telefon (Festnetz oder mobil)")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.telefon))
                  ])
                : _c(
                    "v-text-field",
                    {
                      staticClass: "input-telephone",
                      attrs: {
                        autocomplete: "off",
                        id: "telefon",
                        outlined: "",
                        dense: "",
                        "persistent-placeholder": "",
                        rules: [
                          _vm.rules.required,
                          _vm.rules.valid_phone_number
                        ]
                      },
                      on: {
                        input: function(v) {
                          return _vm.saveFieldValue("telefon", v)
                        }
                      },
                      model: {
                        value: _vm.formData.telefon,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "telefon", $$v)
                        },
                        expression: "formData.telefon"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "prepend-inner" },
                          slot: "prepend-inner"
                        },
                        [_vm._v("+49")]
                      )
                    ]
                  )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("14. Name des Ensembles (optional)")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.name_ensembles))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "name_ensembles",
                      autocomplete: "off",
                      outlined: "",
                      dense: ""
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("name_ensembles", v)
                      }
                    },
                    model: {
                      value: _vm.formData.name_ensembles,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "name_ensembles", $$v)
                      },
                      expression: "formData.name_ensembles"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("15. Künstler/in -Website (optional)")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.url))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      id: "url",
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      type: "url",
                      pattern: "https://.*",
                      "persistent-placeholder": "",
                      placeholder: !_vm.readonly ? "https://example.com" : "",
                      rules: [_vm.rules.valid_url]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("url", v)
                      }
                    },
                    model: {
                      value: _vm.formData.url,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "url", $$v)
                      },
                      expression: "formData.url"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }